export enum COMPANY_SIZE_BUCKET {
  Micro = "Micro", // 1-50
  Small = "Small", // 51-200
  Medium = "Medium", // 201-1000
  Large = "Large", // 1001-5000
  Enterprise = "Enterprise" // 5000+
}

export enum COMPETITOR_CARD_VARIANT {
  FACTS = "Facts",
  STATS = "Stats"
}

export enum REVENUE_BUCKET {
  Micro = "Micro", // <$10M
  Small = "Small", // $10M-$50M
  Medium = "Medium", // $50M-$250M
  Large = "Large", // $250M-$1B
  Enterprise = "Enterprise" // $1B+
}

export enum DISCOVERY_SORT_OPTION {
  NAME = "Name",
  CUSTOMERS_COUNT = "CustomersCount",
  NPS = "Nps",
  LATEST_UPDATES = "LatestUpdates"
}

export enum DISCOVERY_SCOPE {
  ALL = "all",
  WATCHLIST = "watchlist",
  RECOMMENDATIONS = "recommendations"
}

export enum DISCOVERY_SORT_DIRECTION {
  ASC = "Asc",
  DESC = "Desc"
}

export enum DISCOVERY_SUBSCRIPTION_PLAN {
  FREE = "free",
  TRIAL = "trial",
  TRIAL_EXPIRED = "trialExpired",
  PAID = "paid",
  PAID_EXPIRED = "paidExpired"
}

export enum SUBSCRIPTION_BANNER_VARIANT {
  NONE = "none",
  INVITATION = "invitation",
  WARNING = "warning"
}

export enum RENEWAL_STATUS {
  Yes = "Yes",
  No = "No",
  NotSure = "NotSure"
}

export enum ADOPTION_STATUS {
  Pilot = "Pilot",
  User = "User",
  OffBoarding = "OffBoarding",
  NotSure = "NotSure"
}

export enum PERSONA {
  Other = "Other",
  User = "User",
  Influencer = "Influencer"
}

export enum MONITORING_LIST_PANEL_STEPS {
  SELECT_USER = "SelectUser",
  SELECT_COMPANY = "SelectCompany",
  CREATE_COMPANY = "CreateCompany"
}

export enum REPORT_INSIGHT_ENUM {
  NOT_A_LEGITIMATE_CUSTOMER = "NotALegitimateCustomer",
  ONE_OF_THE_INFORMATION_IS_INACCURATE = "OneOfTheInformationIsInaccurate",
  OTHER = "Other"
}

export enum COMPANY_DUPLICATION_TYPE_ENUM {
  WEBSITE = "Website",
  COMPANY_NAME = "CompanyName",
  LINKEDIN_URL = "LinkedInUrl"
}

export enum COMPANY_MONITORING_TABS {
  CUSTOMER_REPORT = "CustomerReport",
  CUSTOMER_SIGNALS = "CustomerSignals"
}

export enum CUSTOMER_LIBRARY_TOUR_STEP {
  DISCOVERY = "discovery",
  SUBSCRIPTION_MODAL = "subscription_modal",
  REPORT = "report",
  SIGNALS = "signals",
  FINAL_SEARCH = "final_search",
  DONE = "done"
}

export enum TOUR_ROUTE_KEY {
  SEARCH = "search",
  REPORT = "report"
}

export enum MONITORING_LIST_ORDER_BY {
  COMPANY_NAME = "companyName",
  COMPANY_WEBSITE = "companyWebsite",
  CLIENT_USER = "clientUserName",
  MODIFIED = "modified",
  SOURCE = "source",
  STATUS = "status",
  CREATED = "created"
}

export enum MONITORING_LIST_SOURCE {
  PROJECT = "Project",
  ADMIN = "Admin",
  CLIENT = "Client"
}

// Entry point a user arrived from when landing on a customer overview page.
// Threaded via router location state and read by the page-view tracker.
export enum CUSTOMER_OVERVIEW_SOURCE {
  DISCOVERY = "discovery",
  BANNER = "banner",
  COMPARE = "compare",
  DEEP_LINK = "deep_link"
}

// The gated action a user attempted when a subscription wall blocked them.
export enum SUBSCRIPTION_GATE_ACTION {
  VIEW_SEGMENT = "view_segment",
  VIEW_INTERVIEWS = "view_interviews"
}

// Careful: the order will be reflected in the dropdown
export enum MONITORING_LIST_COMPANY_STATUS {
  ACTIVE = "Active",
  MONITORING = "Monitoring",
  PAUSED = "Paused"
}

export enum CUSTOMER_LIBRARY_SUBSCRIPTION_TYPE {
  PAID = "Paid",
  TRIAL = "Trial"
}

export enum CUSTOMER_LIBRARY_USER_SUBSCRIPTION_STATUS {
  ACTIVE = "Active",
  EXPIRED = "Expired"
}

export enum GRAPH_TYPE {
  PIE = "pie",
  LINE = "line",
  HISTOGRAM = "histogram",
  MATRIX = "matrix"
}

export enum NPS_PRESET_COLOR {
  Promoter = "green",
  Passive = "orange",
  Detractor = "red"
}

export enum CUSTOMER_SIGNALS_COLUMN_KEY {
  SELECTION = "selection"
}

export enum SIGNAL_HISTORY_COLUMN_KEY {
  LAST_UPDATE = "lastUpdate",
  VALUE = "value",
  NPS = "nps",
  ADOPTION = "adoption",
  RENEWAL_INTENT = "renewalIntent",
  SPEND = "spend"
}

export enum DETAIL_PANEL_TAB {
  EXPERT_PROFILE = "expertProfile",
  CUSTOMER_DEEP_DIVE = "customerDeepDive"
}

export enum TREND_DIRECTION {
  Up = "Up",
  Down = "Down",
  Equal = "Equal",
  Stable = "Stable"
}

export enum PUBLIC_CUSTOMER_OVERVIEW_CTA_TYPE {
  SUBSCRIPTION_EXPIRED = "subscription_expired",
  NEW_USER = "new_user",
  NO_MONITORING_ACCESS = "no_monitoring_access",
  FREE_USER = "free_user",
  TRIAL_ACTIVE = "trial_active",
  PAID_ACTIVE = "paid_active"
}

export enum SUBSCRIPTION_TRACKING_ACTION {
  REQUEST_TRIAL = "Request trial",
  TRIAL_EXPIRED_UPGRADE = "Trial Expired Upgrade",
  DAYS_LEFT_UPGRADE = "Days Left Upgrade",
  SUBSCRIPTION_EXPIRED = "Subscription Expired"
}

export enum SUBSCRIPTION_TRACKING_UNLOCK_CONTENT_MODAL {
  ACTIVATE_TRIAL_MODAL = "Activate Trial Modal",
  TRIAL_EXPIRED_MODAL = "Trial Expired Modal",
  SUBSCRIPTION_ENDING_SOON_MODAL = "Subscription Ending Soon Modal",
  SUBSCRIPTION_EXPIRED_MODAL = "Subscription Expired Modal"
}

export enum CUSTOMER_OVERVIEW_HEADER_KEYS {
  CUSTOMERS_COUNT = "customersCount",
  NPS = "nps",
  SPEND = "spend",
  RENEWAL_RATE = "renewalRate",
  ADOPTION_RATE = "adoptionRate"
}

export enum NPS_RENEWAL_RISK_LEVEL {
  SevereRisk = "SevereRisk",
  HighRisk = "HighRisk",
  MediumRisk = "MediumRisk",
  AtRisk = "AtRisk",
  LowRisk = "LowRisk",
  PromoterRisk = "PromoterRisk",
  Positive = "Positive",
  VeryPositive = "VeryPositive"
}

export enum SPEND_RENEWAL_RISK_LEVEL {
  CriticalRevenueRisk = "CriticalRevenueRisk",
  HighRisk = "HighRisk",
  StrategicGrowth = "StrategicGrowth",
  Watchlist = "Watchlist",
  Growth = "Growth",
  LowPriorityRisk = "LowPriorityRisk",
  Monitor = "Monitor",
  Stable = "Stable"
}

export enum ADOPTION_NPS_RISK_LEVEL {
  FailedPilot = "FailedPilot",
  AtRiskPilot = "AtRiskPilot",
  StrongPilot = "StrongPilot",
  ChurnRisk = "ChurnRisk",
  Fragile = "Fragile",
  Healthy = "Healthy",
  HighChurnRisk = "HighChurnRisk",
  Recoverable = "Recoverable",
  UnplannedExit = "UnplannedExit"
}

export enum SPEND_LEVEL {
  Small = "small",
  Mid = "mid",
  Big = "big"
}

export enum NPSCategory {
  PROMOTER = "promoter",
  NEUTRAL = "neutral",
  DETRACTOR = "detractor"
}

export enum COMPARE_ENTRY_POINT {
  SEARCH = "search",
  COMPANY = "company"
}

export enum DISCOVERY_FILTER_TYPE {
  EMPLOYEE_BUCKETS = "employee_buckets",
  REVENUE_BUCKETS = "revenue_buckets",
  SECTORS = "sectors",
  BUSINESS_MODELS = "business_models",
  REGIONS = "regions",
  SPECIALITIES = "specialities"
}

export enum INVITE_TEAM_SOURCE {
  HERO = "hero",
  SHARE_LINK = "share-link",
  SHARE_PDF = "share-pdf"
}

export enum TEAM_INVITE_MODAL_MODE {
  SHARE = "share",
  DOWNLOAD = "download",
  INVITE = "invite"
}

export enum EMAIL_ELIGIBILITY_STATUS {
  CHECKING = "checking",
  ELIGIBLE = "eligible",
  INELIGIBLE = "ineligible"
}

export enum COMPETITOR_COMPARISON_METRIC {
  NPS = "nps",
  RENEWAL = "renewal",
  ADOPTION = "adoption",
  SPEND = "spend"
}

export enum BENCHMARK_COMPARISON {
  ABOVE = "above",
  BELOW = "below",
  NEUTRAL = "neutral"
}
